import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-31">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60" onClick={onClose} data-id="element-32">
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-33">
            <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between rounded-t-2xl" data-id="element-34">
              <h2 className="font-serif text-xl font-bold text-brand-forest" data-id="element-35">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Cerrar" data-id="element-36">
                <XIcon className="w-5 h-5 text-gray-500" data-id="element-37" />
              </button>
            </div>
            <div className="px-6 py-6 text-gray-700 text-base leading-relaxed space-y-4" data-id="element-38">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  return <>
      <footer className="bg-gray-900 text-gray-400 py-12 px-6 text-center text-sm" data-id="element-39">
        <div className="max-w-3xl mx-auto space-y-4" data-id="element-40">
          <p data-id="element-41">
            Descargo de responsabilidad: La información contenida en este sitio
            web y en el Manual de Digestión Ligera es únicamente para fines
            educativos e informativos. No pretende sustituir el consejo,
            diagnóstico o tratamiento médico profesional.
          </p>
          <p data-id="element-42">
            © {new Date().getFullYear()} Manual de Digestión Ligera. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-6 pt-2" data-id="element-43">
            <button onClick={() => setShowTerms(true)} className="underline hover:text-white transition-colors cursor-pointer" data-id="element-44">
              Términos y Condiciones
            </button>
            <span className="text-gray-600" data-id="element-45">|</span>
            <button onClick={() => setShowPrivacy(true)} className="underline hover:text-white transition-colors cursor-pointer" data-id="element-46">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      {/* Términos y Condiciones Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-47">
        <p className="font-bold" data-id="element-48">Última actualización: abril 2026</p>
        <p data-id="element-49">
          Al acceder y utilizar este sitio web y adquirir el Manual de Digestión
          Ligera, usted acepta cumplir con los siguientes términos y condiciones
          de uso.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-50">
          1. Producto Digital
        </h3>
        <p data-id="element-51">
          El Manual de Digestión Ligera es un producto digital en formato PDF.
          Una vez completada la compra, recibirá acceso inmediato al material.
          Debido a la naturaleza digital del producto, no se aceptan
          devoluciones ni reembolsos una vez descargado el contenido.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-52">
          2. Uso Personal
        </h3>
        <p data-id="element-53">
          El contenido adquirido es para uso personal y exclusivo del comprador.
          Queda prohibida la reproducción, distribución, modificación o reventa
          total o parcial del material sin autorización expresa por escrito.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-54">
          3. Fines Informativos
        </h3>
        <p data-id="element-55">
          La información proporcionada en el manual tiene fines exclusivamente
          educativos e informativos. No constituye consejo médico, diagnóstico
          ni tratamiento. Siempre consulte a un profesional de la salud antes de
          realizar cambios en su dieta o suspender cualquier medicamento.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-56">
          4. Resultados
        </h3>
        <p data-id="element-57">
          Los resultados mencionados en este sitio web son basados en
          experiencias reportadas y pueden variar de persona a persona. No
          garantizamos resultados específicos, ya que estos dependen de factores
          individuales como el estado de salud, la adherencia al programa y
          otros hábitos de vida.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-58">
          5. Modificaciones
        </h3>
        <p data-id="element-59">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en este sitio web.
        </p>
      </LegalModal>

      {/* Política de Privacidad Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-60">
        <p className="font-bold" data-id="element-61">Última actualización: abril 2026</p>
        <p data-id="element-62">
          Su privacidad es importante para nosotros. Esta política describe cómo
          recopilamos, usamos y protegemos su información personal.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-63">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-64">
          Al realizar una compra, podemos recopilar su nombre, dirección de
          correo electrónico e información de pago. Esta información se utiliza
          exclusivamente para procesar su pedido y entregarle el producto
          digital.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-65">
          2. Uso de la Información
        </h3>
        <p data-id="element-66">
          Utilizamos su información personal únicamente para: procesar y
          entregar su compra, enviar confirmaciones de pedido y proporcionar
          soporte al cliente si lo solicita.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-67">
          3. Protección de Datos
        </h3>
        <p data-id="element-68">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger su información personal contra acceso no autorizado,
          alteración, divulgación o destrucción.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-69">
          4. Terceros
        </h3>
        <p data-id="element-70">
          No vendemos, intercambiamos ni transferimos su información personal a
          terceros, excepto a proveedores de servicios de pago necesarios para
          procesar su transacción, quienes están obligados a mantener la
          confidencialidad de dicha información.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-71">
          5. Cookies
        </h3>
        <p data-id="element-72">
          Este sitio web puede utilizar cookies para mejorar la experiencia del
          usuario. Usted puede configurar su navegador para rechazar cookies,
          aunque esto podría afectar la funcionalidad del sitio.
        </p>
        <h3 className="font-serif font-bold text-brand-forest text-lg mt-4" data-id="element-73">
          6. Sus Derechos
        </h3>
        <p data-id="element-74">
          Usted tiene derecho a acceder, rectificar o solicitar la eliminación
          de sus datos personales en cualquier momento.
        </p>
      </LegalModal>
    </>;
}